// Export important config IDs or URLs here
const config = {
  // API_URL: "http://localhost:2626",
  API_URL: "https://fjdv8n9jaf.execute-api.us-west-2.amazonaws.com",
  GOOGLE_API_KEY: "AIzaSyBWBKEmQaP5gUphJc8pa1P-SEjDjgtjw3A",
  GOOGLE_CLIENT_ID:
    "817832900797-m6ouvvag42jtr29aama28trfui7dcq0h.apps.googleusercontent.com",
  TINYMCE_API_KEY: "tc734s8xrtz4fvnftwva6idas3vz5otk3uaqm6iyv2g7j7dw",
};

export default config;
